import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  padding: `${theme.spacing(2)} 0`,
  position: 'relative',
}))

export const ModalContent = styled(Box)(({ theme, width = '90%' }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4),
  maxWidth: width,
  width: '100%',
  maxHeight: '90vh',
  overflow: 'auto',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    maxWidth: '95%',
  },
}))

export const BookingModalContent = styled(Box)(({ theme }) => ({
  width: '90%',
  maxWidth: '900px',
  maxHeight: '90vh',
  overflow: 'auto',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    width: '95%',
    padding: theme.spacing(2),
  },
}))

export const StatusChip = styled(Box)(({ status, theme }) => {
  let color = theme.palette.primary.main
  let backgroundColor = theme.palette.primary.light
  
  switch(status) {
    case 'AC':
      color = theme.palette.success.main
      backgroundColor = theme.palette.success.light
      break
    case 'PP':
      color = theme.palette.warning.main
      backgroundColor = theme.palette.warning.light
      break
    case 'IN':
      color = theme.palette.error.main
      backgroundColor = theme.palette.error.light
      break
    default:
      break
  }
  
  return {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 8px',
    borderRadius: '16px',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: color,
    backgroundColor: backgroundColor,
    height: '24px',
  }
})